import { toast } from 'react-toastify';
import { replaceOrAddById } from '../App/Helpers/store';

export const clientPackagesInitialState = {
	loading: false,
	items: [],
};

export const clientPackagesReducer = (
	state = clientPackagesInitialState,
	action
) => {
	switch (action.type) {
		case 'CLIENTPACKAGES_ADD':
		case 'CLIENTPACKAGES_DELETE':
			return state;

		case 'CLIENTPACKAGES_EDITING':
		case 'CLIENTPACKAGES_LOADING':
			return {
				...state,
				loading: true,
			};

		case 'CLIENTPACKAGES_GET':
			return {
				...state,
				loading: false,
				items: action.payload.data.data,
			};

		case 'CLIENTPACKAGES_EDITED':
		case 'CLIENTPACKAGES_ERROR':
			toast.success('Tiedot tallennettu');
			return {
				...state,
				loading: false,
			};

		case 'GROUP_SET_LOADING':
			let nitems = [...state.items];
			let nindex = nitems.findIndex((val) => {
				// eslint-disable-next-line eqeqeq
				return val.id == action.id;
			});
			if (nindex > -1) {
				nitems[nindex].loading = true;
			}

			return {
				...state,
				items: nitems,
				loading: false,
			};

		case 'GROUP_GET':
			const items = replaceOrAddById(
				[...state.items],
				action.payload.data.data
			);

			return {
				...state,
				items,
				loading: false,
			};

		default:
			return state;
	}
};
